/* SAEGE 02/11/26: Christmas returns line on product pages.
 *
 * Swaps the 30-day line in the trust grid (built by assets/saege-pdp.js) for a
 * tappable line that opens the same popup as the collection pages. It only
 * loads between the dates in snippets/saege-pdp-loader.liquid, so the 30-day
 * line comes back on its own after 24 December.
 *
 * The title and body come from window.SAEGE_PDP_RETURNS, printed by the loader.
 * The body is snippets/saege-collection-returns-copy.liquid, so the collection
 * and product page popups share one piece of wording.
 */
(function () {
  'use strict';

  var R = window.SAEGE_PDP_RETURNS;
  if (!R) return;

  var OLD = '30-day money-back guarantee';
  var CLOSE = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function dialog() {
    var d = document.getElementById('saege-ret-pop');
    if (d) return d;
    d = document.createElement('dialog');
    d.id = 'saege-ret-pop';
    d.className = 'saege-ret-dialog';
    d.setAttribute('aria-labelledby', 'saege-ret-pop-title');
    d.innerHTML = '<div class="saege-ret-dialog__inner"><button type="button" class="saege-ret-close" aria-label="Close">' + CLOSE + '</button><h2 class="saege-ret-dialog__title" id="saege-ret-pop-title"></h2><div class="saege-ret-dialog__body"></div></div>';
    d.querySelector('.saege-ret-dialog__title').textContent = R.title;
    d.querySelector('.saege-ret-dialog__body').innerHTML = R.body;
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('.saege-ret-close')) d.close();
    });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('saege-ret-lock');
    });
    document.body.appendChild(d);
    return d;
  }

  function swap() {
    var spans = document.querySelectorAll('.saege-trust__item > span');
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].textContent.trim() !== OLD) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'saege-ret-trigger';
      b.setAttribute('aria-haspopup', 'dialog');
      b.textContent = R.title;
      var dot = document.createElement('span');
      dot.className = 'saege-ret-i';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = 'i';
      b.appendChild(dot);
      b.addEventListener('click', function () {
        var d = dialog();
        if (typeof d.showModal === 'function') {
          d.showModal();
          document.documentElement.classList.add('saege-ret-lock');
        }
      });
      spans[i].parentNode.replaceChild(b, spans[i]);
      return true;
    }
    return false;
  }

  function start() {
    if (swap()) return;
    var n = 0;
    var iv = setInterval(function () {
      if (swap() || ++n > 160) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
